package com.mgacreative.hotel.feature.admin.ui

import androidx.compose.foundation.layout.*
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.verticalScroll
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.automirrored.filled.ArrowBack
import androidx.compose.material3.*
import androidx.compose.runtime.*
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import com.mgacreative.hotel.shared.ui.designsystem.components.HFButton
import com.mgacreative.hotel.shared.ui.designsystem.components.HFTextField
import com.mgacreative.hotel.shared.ui.designsystem.components.verticalScrollbar
import org.koin.compose.viewmodel.koinViewModel

@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun HotelProfileScreen(onBack: () -> Unit = {}) {
    val viewModel = koinViewModel<AdminViewModel>()
    val profile by viewModel.profile.collectAsState()
    
    LaunchedEffect(Unit) {
        viewModel.loadDashboardData()
    }
    
    var name by remember(profile) { mutableStateOf(profile?.name ?: "") }
    var companyTitle by remember(profile) { mutableStateOf(profile?.companyTitle ?: "") }
    var phone by remember(profile) { mutableStateOf(profile?.phone ?: "") }
    var email by remember(profile) { mutableStateOf(profile?.email ?: "") }
    var address by remember(profile) { mutableStateOf(profile?.address ?: "") }
    var taxOffice by remember(profile) { mutableStateOf(profile?.taxOffice ?: "") }
    var taxNumber by remember(profile) { mutableStateOf(profile?.taxNumber ?: "") }
    var authorizedPerson by remember(profile) { mutableStateOf(profile?.authorizedPerson ?: "") }
    var socialMedia by remember(profile) { mutableStateOf(profile?.social_media ?: "") }

    val scrollState = rememberScrollState()

    Scaffold(
        contentWindowInsets = WindowInsets(0, 0, 0, 0),
        topBar = {
            TopAppBar(
                title = { Text("Otel Profili", fontWeight = FontWeight.Bold) },
                navigationIcon = {
                    IconButton(onClick = onBack) {
                        Icon(Icons.AutoMirrored.Filled.ArrowBack, contentDescription = "Geri")
                    }
                }
            )
        }
    ) { padding ->
        Column(
            modifier = Modifier
                .fillMaxSize()
                .padding(padding)
                .verticalScroll(scrollState)
                .verticalScrollbar(scrollState)
                .padding(16.dp)
        ) {
            HFTextField(
                value = name,
                onValueChange = { name = it },
                label = "Otel Ticari Adı"
            )
            Spacer(Modifier.height(12.dp))
            HFTextField(
                value = companyTitle,
                onValueChange = { companyTitle = it },
                label = "Şirket / Otel Resmi Ünvanı"
            )
            Spacer(Modifier.height(12.dp))
            HFTextField(
                value = phone,
                onValueChange = { phone = it },
                label = "Telefon Numarası"
            )
            Spacer(Modifier.height(12.dp))
            HFTextField(
                value = email,
                onValueChange = { email = it },
                label = "E-posta Adresi"
            )
            Spacer(Modifier.height(12.dp))
            HFTextField(
                value = address,
                onValueChange = { address = it },
                label = "Açık Adres"
            )
            Spacer(Modifier.height(12.dp))
            Row(horizontalArrangement = Arrangement.spacedBy(8.dp)) {
                Box(modifier = Modifier.weight(1f)) {
                    HFTextField(
                        value = taxOffice,
                        onValueChange = { taxOffice = it },
                        label = "Vergi Dairesi"
                    )
                }
                Box(modifier = Modifier.weight(1f)) {
                    HFTextField(
                        value = taxNumber,
                        onValueChange = { taxNumber = it },
                        label = "Vergi Numarası"
                    )
                }
            }
            Spacer(Modifier.height(12.dp))
            HFTextField(
                value = authorizedPerson,
                onValueChange = { authorizedPerson = it },
                label = "Otel Yetkilisi (Adı Soyadı / Unvanı)"
            )
            Spacer(Modifier.height(12.dp))
            HFTextField(
                value = socialMedia,
                onValueChange = { socialMedia = it },
                label = "Sosyal Medya Linki (Örn: Instagram)"
            )
            Spacer(Modifier.height(24.dp))
            
            HFButton(
                text = "Kaydet",
                onClick = {
                    viewModel.updateProfile(
                        name = name, 
                        phone = phone, 
                        email = email, 
                        address = address, 
                        socialMedia = socialMedia,
                        companyTitle = companyTitle,
                        taxOffice = taxOffice,
                        taxNumber = taxNumber,
                        authorizedPerson = authorizedPerson
                    )
                    onBack()
                }
            )
        }
    }
}
